export default "__VITE_ASSET__DbKDpaCV__"